import image1 from "./image-1.png";
import image2 from "./image-2.jpg";
import image3 from "./image-3.jpg";
import image4 from "./image-4.jpg";

const placeholderImages = [image1, image2, image3, image4];

const alphabet = ["A", "B", "C", "D","E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z","0", "1", "2", "3", "4", "5", "6", "7", "8", "9","a", "b", "c", "d","e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z"];

const getRandomPlaceholder = (id?: string) => {
  if(!id) return placeholderImages[Math.floor(Math.random() * placeholderImages.length)];
  const char = id.charAt(0);
  const index = alphabet.indexOf(char);
  // If character not found, fallback to random
  if (index === -1) return placeholderImages[Math.floor(Math.random() * placeholderImages.length)];
  return placeholderImages[index % placeholderImages.length];
};

export default getRandomPlaceholder;
